import { analytics } from './analytics'
import { SearchEvents } from './events'

export type SearchOpenSource = 'sidebar' | 'shortcut'

export function trackSearchOpened(source: SearchOpenSource): void {
  analytics.track(SearchEvents.OPENED, { source })
}
